import { deletePaymentInstrument } from "library/api/payments";
import { useMutation } from "react-query";

export const useDeletePayment = () =>
  useMutation((id: string) => deletePaymentInstrument(id));
